import Tool from "./Tool"

export default Tool;